import styled from 'styled-components';
import colors from 'theme/colors';

export const AmendmentsList = styled.section`
  background-color: ${colors.lightestGray};
  border-radius: 3px;
  border: 1px solid ${colors.lightGray};
  padding: 1rem;
  margin-top: -100px;
  position: relative;
  h3 {
    font-size: 1rem;
    font-weight: 600;
  }
  ul {
    list-style: unset;
    padding: 0;
    max-height: 100px;
    overflow: auto;
    margin: 0;
  }
  li {
    margin-bottom: 0.5rem;
    .amendment-name {
      color: ${colors.primary};
    }
    > .ant-btn {
      padding-left: 0;
    }
    .btn-amendment-upload-delete {
      color: ${colors.lightGray};
      &:hover {
        color: ${colors.alert};
      }
    }
  }
`;
